import React, { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet-async';
import { Box, Card, Tabs, Tab, Divider, Stack, IconButton, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useModuleNavigate } from "../../layouts/main/ModuleNavigation";
import { useSchemeStoreAdd } from './schemeStoreAdd';
import LoadingProgressBar from '../../components/loading-progressbar/loadingprogressbar';
import EditHeaderDef from '../SchemeDefination/SchemeDefinationPages/EditHeaderDef';

// Import tab components
import SchemeDefinitionAdd from './SchemeTabs/SchemeDefinitionAdd';
import PopUpHandle from '../../commons/PopUpHandle';
import { useAppStore } from '../../store/appStore';


const SchemeDefMasterAdd = () => {
    const navigate = useModuleNavigate();


    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    const [activeTab, setActiveTab] = useState(0); 


    const displayAlert = (type, message, show) => {
        setAlertType(type);
        setAlertMessage(message);
        setShowAlert(show);
    }

    const hideAlert = () => {
        setAlertType('');
        setAlertMessage('');
        setShowAlert(false);
    }



    const [open, setOpen] = useState(false);
    const [errorr, setError] = useState(0);
    const [errorCode, setErrorCode] = useState(null);

    const handleClose = () => {
        setOpen(false);
    };


    const {
        setIsListChanged,
    } = useAppStore();


    const {
        error,
        loading,
        setApiResponse,
        apiResponse,
        setDefinitionData,
        errorTab,
        fetchThresholdSettings,
        resetSchemeDetails,
        fetchSchemeControls
    } = useSchemeStoreAdd();


    useEffect(() => {
        if (errorTab) {
            displayAlert('error', errorTab, true);
            setTimeout(() => {
                hideAlert();
            }, 2500);
        }
    }, [errorTab]);
    useEffect(() => {
        if (error) {
            setErrorCode(error?.response?.status);
            setError(error?.response?.data?.error?.message);
            setOpen(true);
        }
    }, [error]);
   
    useEffect(() => {
         
        if (apiResponse && apiResponse?.status === 200) {
            displayAlert('success', apiResponse?.data?.Message || 'Scheme added successfully.', true);
            setIsListChanged(true);

            setTimeout(() => {
                hideAlert();
                setApiResponse(null);
                navigate(`/scheme/scheme-definition/edit/${apiResponse?.data?.SchemeId}`);
            }, 2500);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiResponse]);


    useEffect(() => {
        resetSchemeDetails();
        setDefinitionData(null)
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    

    useEffect(() => {
        fetchThresholdSettings();
        fetchSchemeControls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const tabList = [
        { label: 'Definition', component: <SchemeDefinitionAdd /> },
    ];

  


    return (
        <Card sx={{ margin: '5px 2px', padding: '10px', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Helmet>
                <title>Scheme Definition | Proclaimz</title>
            </Helmet>

            <EditHeaderDef pageType='add' scName='Add Scheme' />
            {/* Tabs Header */}
            <Tabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
            >
                {tabList.map((tab, idx) => (
                    <Tab key={idx} label={tab.label} /> // NOSONAR
                ))}
            </Tabs>
          
            <Divider />

            <Box sx={{ flexGrow: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                {tabList[activeTab].component}
            </Box>
            {showAlert && (
                <Stack sx={{ height: '2em', width: '30%', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                    <Alert
                        severity={alertType}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setAlertType('');
                                    setAlertMessage('');
                                    setShowAlert(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                    >
                        {alertMessage}
                    </Alert>
                </Stack>
            )}
            {
                open && (
                    <PopUpHandle open={open} handleClose={handleClose} error={errorr} errorCode={errorCode} />
                )
            }
            {loading && <LoadingProgressBar />}
        </Card>
    );
};


export default SchemeDefMasterAdd;
